
var img_w = 1280;
var img_h = 700;

var img_w_sp = 375;
var img_h_sp = 667;

var set_img_w;
var set_img_h;
var anchor_center_x;
var anchor_center_y;

var w;
var h;

var r_max;

var tl_mask;
var tl_circle_border;
var tl_circle_text;

var scroll_mask;
var scroll_border;
var scroll_text;



/* svgサイズセット */
function set_bgSize() {
	let $ = jQuery;
	w = window.innerWidth;
	// h = window.innerHeight;
	h = $('.toppage--bg').height();

	//スクリーンサイズ長方形に外接する円の半径
	var adj = 1.125; //調整値
	r_max = Math.sqrt(Math.pow(w * adj, 2) + Math.pow(h * adj, 2)) * 0.5;

	//svg viewboxを画面サイズに設定
	gsap.set('.toppage--bg svg', {
		attr: {
			viewBox: '0 0 ' + w + ' ' + h
		}
	})

	//マスク位置をsvg中央に設定
	gsap.set('.svg__circle', {
		attr: {
			cx: w * 0.5,
			cy: h * 0.5,
		}
	})

	//円形テキストの最大サイズを設定
	gsap.set('.circletext', {
		width: r_max * 2 + r_max
	})

	//画面サイズを写真アスペクト比と比較してsize:cover, position:centerに設定
	if ($(window).width() > 450) {
		//pc
		if (w / h >= img_w / img_h) {
			set_img_w = w;
			set_img_h = w * (img_h / img_w);
		} else {
			set_img_w = h * (img_w / img_h);
			set_img_h = h;
		}
		anchor_center_x = (w * 0.5) - (set_img_w * 0.5);
		anchor_center_y = (h * 0.5) - (set_img_h * 0.5);

		gsap.set('.svg__image.hide_sp', {
			attr: {
				width: set_img_w,
				height: set_img_h,
				transform: 'translate(' + anchor_center_x + ' ' + anchor_center_y + ')'
			}
		})
	} else {
		//sp
		if (w / h >= img_w_sp / img_h_sp) {
			set_img_w = w;
			set_img_h = w * (img_h_sp / img_w_sp);
		} else {
			set_img_w = h * (img_w_sp / img_h_sp);
			set_img_h = h;
		}
		anchor_center_x = (w * 0.5) - (set_img_w * 0.5);
		anchor_center_y = (h * 0.5) - (set_img_h * 0.5);

		gsap.set('.svg__image.hide_pc', {
			attr: {
				width: set_img_w,
				height: set_img_h,
				transform: 'translate(' + anchor_center_x + ' ' + anchor_center_y + ')'
			}
		})
	}

	//初期サイズ
	var ratio_first = 0.025;
	if ($(window).width() > 450) {
		var ratio_first = 0.025; //pc
	} else {
		var ratio_first = 0.05; //sp
	}
	var rotate_speed = 10;
	gsap.set('.svg__circle', {
		attr: {
			r: w * ratio_first,
		}
	})
	gsap.set('.svg__circle.border', {
		attr: {
			r: w * ratio_first + 1,
		}
	})
	gsap.set('.circletext img', {
		scale: (w * ratio_first) / $('.circletext').width() * 3.25,
	})

	gsap.to('.circletext span', rotate_speed, {
		rotate: 360,
		repeat: -1,
		ease: 'none',
	})

}


/* アニメーション */
function anim_bg() {
	let $ = jQuery;
	// maskアニメーション
	tl_mask = gsap.timeline();
	tl_mask.to('#svgmask .svg__circle', {
		attr: {
			r: r_max,
		},
		ease: "slow",
	})
	//border_circleアニメーション
	tl_circle_border = gsap.timeline();
	tl_circle_border.to('.svg__circle.border', {
		attr: {
			r: r_max + 1,
		},
		ease: "slow",
	})
	//circle_textアニメーション
	var tl_circle_text = gsap.timeline();
	tl_circle_text.to('.circletext img', {
		scale: 1,
		rotate: 360 * 1.5,
		ease: "slow",
	})

	scroll_mask = ScrollTrigger.create({
		animation: tl_mask,
		trigger: '.toppage--bg--spacer',
		scrub: 0.75,
		start: "0% 0%",
		end: "90% 0%"
	});
	scroll_border = ScrollTrigger.create({
		animation: tl_circle_border,
		trigger: '.toppage--bg--spacer',
		scrub: 0.75,
		start: "0% 0%",
		end: "90% 0%"
	});
	scroll_text = ScrollTrigger.create({
		animation: tl_circle_text,
		trigger: '.toppage--bg--spacer',
		scrub: 0.75,
		start: "0% 0%",
		end: "90% 0%",
		onEnter: function () {
			gsap.killTweensOf('.circletext span');
		},
		onLeaveBack: function () {
			var rotate_speed = 10;
			var deg_str = $('.circletext span').attr('style').match(/(.+ rotate\()(.+)(deg.+)/);
			var deg = Number(deg_str[2]);
			gsap.to('.circletext span', rotate_speed, {
				rotate: deg + 360,
				repeat: -1,
				ease: 'none',
			})
		},
	});
}


function set_randomPh() {
	let $ = jQuery;
	var delay_curtain = 1000; //スプラッシュスクリーンの最低待ち時間
	path = path+'/assets/img/front/';
	var fileName = 'top_bg';



	//最初の一回目はph差し替えなし
	// var flg = Cookies.get('bgPh');
	// if (flg === undefined) {
	// 	Cookies.set('bgPh', true, { expires: 0.5 }); //0.5日保持
	// 	var phNum = 4;
	// } else {
	// 	var phNum = randomAry[Math.floor(Math.random() * randomAry.length)];
	// }
	var phNum = "";

	var sourceAry = [
		path + fileName + phNum + '_blur.jpg',
		path + fileName + phNum + '_blur_sp.jpg',
		path + fileName + phNum + '.jpg',
		path + fileName + phNum + '_sp.jpg'
	];

	//pc
	$('.toppage--bg .image--blur.pc').attr('xlink:href', path + fileName + phNum + '_blur.jpg');
	$('.toppage--bg .image--normal.pc').attr('xlink:href', path + fileName + phNum + '.jpg');

	//sp
	$('.toppage--bg .image--blur.sp').attr('xlink:href', path + fileName + phNum + '_blur_sp.jpg');
	$('.toppage--bg .image--normal.sp').attr('xlink:href', path + fileName + phNum + '_sp.jpg');


	var imgAry = [];
	var loadedCounter = 0;

	for (i = 0; i < sourceAry.length; i++) {
		var imgObj = new Image();
		imgAry.push({
			imgObj: imgObj,
			src: sourceAry[i]
		})
	}

	for (var i = 0; i < imgAry.length; i++) {
		imgAry[i].imgObj.onload = function () {
			loadedCounter++;
			if (loadedCounter == imgAry.length) {
				setTimeout(function () {
					releaseScroll(); //スクロール禁止解除
					$('body').addClass('loaded');
				}, delay_curtain);
			}
		};
		imgAry[i].imgObj.src = imgAry[i].src;
	}

}
var tl_copy;
var scroll_copy;

function toppage_copy() {
	// copyアニメーションIN
	tl_copy = gsap.timeline();
	// tl_copy
	// 	.to('.toppage--bg', {
	// 		display: 'none',
	// 	})
	tl_copy
		.to('.toppage--bg', {
			opacity: 0,
			ease: "slow",
		},'set1')

	scroll_copy = ScrollTrigger.create({
		animation: tl_copy,
		trigger: '.top-view .g-l-wrapper',
		scrub: 1,
		start: "0% 0%",
		end: "90% 0%",
	});

}
//背景blur
function bg_blur(speed, opacity) {
	gsap.to('.image--normal', speed, {
		opacity: opacity,
	})
}

/* スクロール ON/OFF */
function handleScroll(event) {
	event.preventDefault();
	event.stopPropagation();
}
//スクロール禁止
function stopScroll() {
	window.addEventListener('mousewheel', handleScroll, { passive: false });
	window.addEventListener('MozMousePixelScroll', handleScroll, { passive: false });
	window.addEventListener('touchmove', handleScroll, { passive: false });
}
//スクロール復帰
function releaseScroll() {
	window.removeEventListener('mousewheel', handleScroll, { passive: false });
	window.removeEventListener('MozMousePixelScroll', handleScroll, { passive: false });
	window.removeEventListener('touchmove', handleScroll, { passive: false });
}

function scroll_hide(tl){
  var nodelist = document.querySelectorAll('.toppage__index');
  var node = Array.prototype.slice.call(nodelist, 0).reverse();
  var options = {
    root: null,
    rootMargin: '0% 0%',
    threshold: 0
  }

  var callback = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        if($(window).scrollTop() != 0){
          gsap.to(['.toppage__scroll', '.toppage__scroll--sp'], 0.5, {
            y: -20,
            opacity: 0,
            onComplete: function(){
              tl.pause();
            }
          })
        }
      } else {
        if ($(window).scrollTop() > 300){
          gsap.to(['.toppage__scroll', '.toppage__scroll--sp'], 0.5, {
            y: 0,
            opacity: 1,
            onComplete: function () {
              tl.play(0);
            }
          })
        }
      }
    })
  }

  var observer = new IntersectionObserver(callback, options);
  node.forEach(function (obj) {
    observer.observe(obj);
  })
}


function animate_scroll(speed){
  var tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });
  tl.to('.scroll__wheel', speed, {
    y: '150%',
    ease: 'power2.inOut',
  })
  return tl;
}

function animate_scroll_sp(speed) {
  var tl = gsap.timeline({ repeat: -1 });
  tl
    .to('.toppage__scroll--sp .scroll__bar', speed, {
      scaleY: 0,
      transformOrigin: '0% 100%',
      ease: 'power2.inOut',
    })
    .to('.toppage__scroll--sp .scroll__bar', speed, {
      scaleY: 1,
      transformOrigin: '100% 0%',
      ease: 'power2.inOut',
    })
}



stopScroll(); //スクロール禁止

jQuery(function ($) {
  var tl_scroll = animate_scroll(1.5);
  var tl_scrollbar = animate_scroll_sp(1.5);

	set_randomPh();
	set_bgSize();
	anim_bg();
	toppage_copy();
	// toppage_news(12); //引数はspeed割合
	scroll_hide(tl_scroll);

	setTimeout(function(){
    gsap.to('.toppage__scroll', 1, {
      y: 0,
      opacity: 1
    })
    tl_scroll.play();
  }, 1500)

	/*-- resize --*/
	var timer_resize = 0;
	var lastInnerWidth = window.innerWidth;
	$(window).on('resize', function () {
		$('.svg__circle, .circletext').addClass('hidden');
		if (timer_resize > 0) {
			clearTimeout(timer_resize);
		}
		if ($(window).width() > 450) {
			//pc
			timer_resize = setTimeout(function () {
				set_bgSize();
				lastInnerWidth = window.innerWidth;
				scroll_mask.kill(true);
				scroll_border.kill(true);
				scroll_text.kill(true);
				anim_bg();
				$('.svg__circle, .circletext').removeClass('hidden');
			}, 200)
		} else {
			//spは横幅リサイズのみ対応
			if (lastInnerWidth != window.innerWidth) {
				set_bgSize();
				lastInnerWidth = window.innerWidth;
				timer_resize = setTimeout(function () {
					lastInnerWidth = window.innerWidth;
					scroll_mask.kill(true);
					scroll_border.kill(true);
					scroll_text.kill(true);
					anim_bg();
				}, 0)
			}
			$('.svg__circle, .circletext').removeClass('hidden');
		}
	})


})
